<template>
  <div class="campaign-social-links-wrapper">
    <form action="#" @submit.prevent="submitForm" class="form" ref="form">
      <div class="row margin-bottom-20">
        <div class="col-sm-12" v-if="showTitle">
          <h3 class="text-left text-normal">
            Social Links <span class="text-gray text-normal"> (Optional)</span>
          </h3>
        </div>
        <div class="col-sm-12">
          <p>Add Social Profiles</p>
        </div>
        <div class="col-sm-12">
          <div class="text-left text-danger" v-if="errors.has('internalError')">
            There was an error processing your personal information. Please try
            again later.
          </div>
        </div>
      </div>

      <div class="margin-top-0 margin-bottom-20">	  	
        <div class="flex-container margin-bottom-20 social-wrapper" @click="visibilityFacebook = !visibilityFacebook"
        >
          <div class="social-logo p-9">
            <img src="/dist/site/static/icons/social-facebook.svg" alt="facebook">
          </div>
          <div class="paragraph mt-21">
            <p class="social-title">Facebook</p>
          </div>
          <div class="fi p-9 ml-auto">
            <font-awesome-icon
              v-if="!visibilityFacebook"
              icon="chevron-down"
              class="w-18"
            />
            <font-awesome-icon
              v-if="visibilityFacebook"
              icon="chevron-up"
              class="w-18"
            />
          </div>
        </div>
        <div class="row" v-if="visibilityFacebook">
          <div class="col-xs-12 col-sm-6 col-md-6">
            <div class="form-group margin-bottom-30">
              <input-label
                type="text"
                css-class="form-control"
                v-model="formData.facebook_page"
                placeholder="Facebook Page URL"
                note="Format: https://www.facebook.com"
              />
              <div
                class="invalid-feedback-red"
                v-if="errors.has('facebook_page')"
              >
                {{ errors.get("facebook_page") }}
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6">
            <div class="form-group margin-bottom-30">
              <input-label
                type="text"
                css-class="form-control"
                v-model="formData.facebook_title"
                placeholder="Facebook Share Title"
              />
              <div
                class="invalid-feedback-red"
                v-if="errors.has('facebook_title')"
              >
                {{ errors.get("facebook_title") }}
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="visibilityFacebook">
          <div class="col-xs-12">
            <div class="form-group margin-bottom-30">
              <label class="hh-input-label" for="facebook_share_message"
                >Facebook Share Message:</label
              >
              <textarea
                class="form-control campaign-text-area h-100"
                placeholder="This is where you can further detail what you want as the body of the message that is pre-defined when a user clicks one of the share buttons from your campaign page."
                id="facebook_share_message"
                v-model="formData.facebook_share_message"
              ></textarea>
            </div>
          </div>
        </div>

        <div
          class="flex-container margin-bottom-20 social-wrapper"
          @click="visibilityTwitter = !visibilityTwitter"
        >
          <div class="social-logo p-9">
            <img src="/dist/site/static/icons/social-twitter.svg" alt="twitter">
          </div>
          <div class="paragraph mt-21">
            <p class="social-title">Twitter</p>
          </div>
          <div class="fi p-9 ml-auto">
            <font-awesome-icon
              v-if="!visibilityTwitter"
              icon="chevron-down"
              class="w-18"
            />
            <font-awesome-icon
              v-if="visibilityTwitter"
              icon="chevron-up"
              class="w-18"
            />
          </div>
        </div>

        <div class="row" v-if="visibilityTwitter">
          <div class="col-xs-12 col-sm-6 col-md-6">
            <div class="form-group margin-bottom-30">
              <input-label
                type="text"
                css-class="form-control"
                v-model="formData.twitter_page"
                placeholder="Twitter Page URL"
                note="Format: https://www.helpahero.com"
              />
              <div
                class="invalid-feedback-red"
                v-if="errors.has('twitter_page')"
              >
                {{ errors.get("twitter_page") }}
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6">
            <div class="form-group margin-bottom-30">
              <input-label
                type="text"
                css-class="form-control"
                v-model="formData.facebook_title"
                placeholder="Twitter Share Title"
              />
              <div
                class="invalid-feedback-red"
                v-if="errors.has('facebook_title')"
              >
                {{ errors.get("facebook_title") }}
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="visibilityTwitter">
          <div class="col-xs-12">
            <div class="form-group margin-bottom-30">
              <label class="hh-input-label" for="twitter_tweet_message"
                >Twitter Tweet:</label
              >
              <textarea
                class="form-control campaign-text-area"
                placeholder="Enter tweet contents here"
                id="twitter_tweet_message"
                v-model="formData.twitter_tweet_message"
              ></textarea>
            </div>
          </div>
        </div>

        <div
          class="flex-container margin-bottom-20 social-wrapper"
          @click="visibilityInstagram = !visibilityInstagram"
        >
          <div class="social-logo p-9">
            <img src="/dist/site/static/icons/social-instagram.svg" alt="instagram">
          </div>
          <div class="paragraph mt-21">
            <p class="social-title">Instagram</p>
          </div>
          <div class="fi p-9 ml-auto">
            <font-awesome-icon
              v-if="!visibilityInstagram"
              icon="chevron-down"
              class="w-18"
            />
            <font-awesome-icon
              v-if="visibilityInstagram"
              icon="chevron-up"
              class="w-18"
            />
          </div>
        </div>
        <div class="row" v-if="visibilityInstagram">
          <div class="col-xs-12">
            <div class="form-group margin-bottom-30">
              <input-label
                type="text"
                css-class="form-control"
                v-model="formData.instagram_page"
                placeholder="Instagram"
                note="Format: https://www.instagram.com"
              />
              <div
                class="invalid-feedback-red"
                v-if="errors.has('instagram_page')"
              >
                {{ errors.get("instagram_page") }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex-container margin-bottom-20 social-wrapper">
          <div class="social-logo p-9">
            <img
              src="/dist/site/static/icons/linkedin.png"
              alt="Linkedin icon"
              class="w-24"
            />
          </div>
          <div class="paragraph mt-21">
            <p class="social-title">LinkedIn</p>
          </div>
          <div
            class="fi p-9 ml-auto"
            @click="visibilityLinkedIn = !visibilityLinkedIn"
          >
            <font-awesome-icon
              v-if="!visibilityLinkedIn"
              icon="chevron-down"
              class="w-18"
            />
            <font-awesome-icon
              v-if="visibilityLinkedIn"
              icon="chevron-up"
              class="w-18"
            />
          </div>
        </div>

        <div class="row" v-if="visibilityLinkedIn">
          <div class="col-xs-12">
            <div class="form-group margin-bottom-30">
              <input-label
                type="text"
                css-class="form-control"
                v-model="formData.linkedin_url"
                placeholder="LinkedIn"
                note="Format: https://www.linkedin.com"
              />
              <div
                class="invalid-feedback-red"
                v-if="errors.has('linkedin_url')"
              >
                {{ errors.get("linkedin_url") }}
              </div>
            </div>
          </div>
        </div>

        <div class="row margin-top-40">
          <div class="col-xs-12">
            <div class="form-group margin-bottom-30">
              <input-label
                type="text"
                css-class="form-control"
                v-model="formData.campaign_website"
                placeholder="Website Campaign URL"
                note="Format: https://www.helpahero.com"
              />
              <div
                class="invalid-feedback-red"
                v-if="errors.has('campaign_website')"
              >
                {{ errors.get("campaign_website") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row margin-bottom-20 margin-top-20" v-if="!isLoading">
        <div class="form-group col-sm-6" v-if="!editMode">
         	<button type="button"  @click="saveAsDraftAction"
						      class="btn hh-btn" style="height: 56px; border: 2px solid #1DC071; color: #1DC071; background: white; width: 100%; font-family: Circular Std;
                  font-size: 16px; line-height: 16px; text-align: center; color: #1DC071;" name="Save as draft">
							Save as Draft
			    </button>
        </div>
        <div class="form-group col-sm-6" v-if="!editMode" :disabled="!isFormReady">
          <button type="submit" class="btn hh-btn hh-btn-green btn-responsive" style="height: 56px; width: 100%;" name="Continue to preview">
							Continue to Preview
					</button>
        </div>
        <div class="form-group col-sm-6" v-if="editMode">
          <button type="button" v-on:click="backAction"
                  class="btn hh-btn back-btn" name="Cancel">
            Cancel
          </button>
        </div>
        <div class="form-group col-sm-6" v-if="editMode">
          <button type="submit" :disabled="loading" class="btn save-btn hh-btn-green" name="Save changes">
            Save Changes
          </button>
        </div>
       	<div class="row back-row" v-if="!editMode" >
          <div class="col-md-12 text-center margin-bottom-20">
           	<img src="/dist/site/static/icons/go_back.svg" style="transform: rotate(180deg);" alt="Go back">
            <span class="btn-responsive" style="font-family: Circular Std; font-size: 16px; line-height: 16px; text-align: center;color: #ACACAC;"
              v-on:click="backAction">
              Go Back
            </span>
				  </div>
        </div>
      </div>

      
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import InputLabel from "../form/elements/InputLabel";
import { scrollTo } from "../../utils/componentHelper";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import constants from "../../config";
export default {
  name: "CampaignSocialLinks",

  components: {
    InputLabel,
    "font-awesome-icon": FontAwesomeIcon,
  },

  props: {
    campaignData: Object,
    campaignImages: Object,
    staticData: {
      states: Object,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showSkipButton: {
      type: Boolean,
      default: true,
    },
    showSaveAsDraft: {
      type: Boolean,
      default: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    nextButtonText: {
      type: String,
      default: "Preview Campaign",
    },
  },

  data: () => {
    return {
      loading: true,
      dataAnalysed: false,
      forceRecompute: 0,
      campaignSlug: null,
      componentsLoadingStatus: {
      },
      formData: {
        informationType: "campaign-social-links",
        method: "put",
        withFiles: false,
        step: 3,
        images: {
          type: Object,
          default: {},
        },
        facebook_page: null,
        facebook_title: null,
        facebook_share_message: null,
        twitter_page: null,
        twitter_tweet_message: null,
        instagram_page: null,
        linkedin_url: null,
        campaign_website: null,
      },
      visibilityFacebook: false,
      visibilityInstagram: false,
      visibilityTwitter: false,
      visibilityLinkedIn: false,
    };
  },

  beforeMount() {
    this.campaignSlug = this.campaignData.slug;

    this.formData.facebook_page = this.campaignData.facebook_page;
    this.formData.facebook_title = this.campaignData.facebook_title;
    this.formData.facebook_share_message =
      this.campaignData.facebook_share_message;
    this.formData.twitter_page = this.campaignData.twitter_page;
    this.formData.facebook_title = this.campaignData.facebook_title;
    this.formData.twitter_tweet_message =
      this.campaignData.twitter_tweet_message;
    this.formData.instagram_page = this.campaignData.instagram_page;
    this.formData.linkedin_url = this.campaignData.linkedin_url;
    this.formData.campaign_website = this.campaignData.campaign_website;
    
    this.loading = false;
  },

  mounted() {},

  methods: {
    ...mapActions("campaign", ["storeInformation", "saveAsDraft"]),

    cancelAction() {
      window.location = "/dashboard";
    },

    backAction() {
      this.$emit("navigateBack");
    },

    skipAction() {
      this.$emit("navigateNext");
    },

    componentLoading(componentName, value) {
      this.componentsLoadingStatus[componentName] = value;
    },

    imagesUpdated(images) {
      this.$emit("imagesUpdated", images);
    },

    submitForm() {
      this.loading = true;
      this.formData.campaignSlug = this.campaignSlug;

      this.storeInformation(this.formData).then(() => {
        this.forceRecompute++;
        this.loading = false;
        if (this.status === "success") {
          this.$emit("formSubmitted");
        } else {
          scrollTo(this.$refs["form"]);
        }
      });
    },

   		saveAsDraftAction() {
				this.loading = true
				this.formData.campaignSlug = this.campaignSlug

				this.storeInformation(this.formData).then(() => {
					if (this.status === 'success') {
						this.$emit('formSubmitted')
            this.saveAsDraft(this.campaignSlug);
            this.loading = false;
              this.forceRecompute++;
              this.cancelAction();
            
					} else {
						scrollTo(this.$refs['form'])
					}
				})
			},

  },

  computed: {
    isDataFetched() {
      return !_.isEmpty(this.campaignData);
    },

    storeInformationData: {
      get() {
        return this.$store.getters["campaign/storeInformationData"](
          this.campaignSlug,
          this.formData.informationType,
          this.forceRecompute
        );
      },
    },

    status: {
      get() {
        return this.$store.getters["campaign/storeInformationStatus"](
          this.campaignSlug,
          this.formData.informationType,
          this.forceRecompute
        );
      },
    },

    errors: {
      get() {
        return this.$store.getters["campaign/storeInformationErrors"](
          this.campaignSlug,
          this.formData.informationType,
          this.forceRecompute
        );
      },
    },

    saveAsDraftData: {
      get() {
        return this.$store.getters["campaign/saveAsDraftData"](
          this.campaignSlug,
          this.forceRecompute
        );
      },
    },

    isLoading() {
      for (let component in this.componentsLoadingStatus) {
        if (this.componentsLoadingStatus[component]) {
          return true;
        }
      }

      return this.loading;
    },

    isFormReady() {
      return !this.loading;
    },

    logoEndpoint() {
      if (_.isEmpty(this.campaignSlug)) {
        return null;
      }

      return `${constants.BASE_URL}campaign/${this.campaignSlug}/logo`;
    },

    uploadCampaignImagesEndpoint() {
      return `${constants.BASE_URL}campaign/upload-image/${this.campaignSlug}`;
    },
  },

  watch: {
    isLoading(to, from) {
      this.$emit("componentLoading", "campaignComponent", to);
    },
  },
};
</script>

<style scoped>
.back-row {
  cursor: pointer;
}
h3 {
  font-family: Circular Std;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 14px;
  color: #000000;
}

h4 {
  font-family: Circular Std;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.005em;
  color: #acacac;
}

p {
  font-family: Circular Std;
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 15px;
  color: #aeaeae;
}

.social-wrapper {
  background: #fcfcfc;
  border: 2px solid #fcfcfc;
  box-sizing: border-box;
  border-radius: 4px;
  height: 55px;
  justify-content: flex-start;
}

.p-9 {
  padding: 9px;
}

.mt-21 {
  margin-top: 21px;
}

.ml-auto {
  margin-left: auto;
}

.w-18 {
  width: 18px !important;
}

.w-16 {
  width: 16px !important;
}

.w-24 {
  width: 24px;
}

.h-100 {
  height: 100px;
}

.social-title {
  font-family: Circular Std;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #727272;
}

.justify-content-center {
  justify-content: center !important;
}

.float-right {
  float: right;
}

.save-as-draft {
  font-family: Circular Std;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.005em;
  color: #acacac;
}
</style>


